import { render } from "./ReservationInstructionsModal.vue?vue&type=template&id=24e78af5&scoped=true&ts=true&lang=pug"
import script from "./ReservationInstructionsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReservationInstructionsModal.vue?vue&type=script&setup=true&lang=ts"

import "./ReservationInstructionsModal.vue?vue&type=style&index=0&id=24e78af5&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24e78af5"]])

export default __exports__